import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { packageService } from "../../services";
import PackageCard from "../PackageCard";

import AOS from "aos";
import "aos/dist/aos.css";

const PackagesSection = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const loadPackages = async () => {
      try {
        const data = await packageService.getAllPublic();
        setPackages(data);
      } catch (error) {
        console.error("Error loading packages:", error);
      } finally {
        setLoading(false);
      }
    };
    loadPackages();
  }, []);

  // No mostrar la seccion si no hay paquetes o esta cargando
  if (loading || packages.length === 0) {
    return null;
  }

  return (
    <section id="promotions" className="py-10 bg-secondary">
      <div className="container mx-auto lg:px-0">
        <div className="text-center">
          <div className="font-tertiary uppercase text-[15px] tracking-[6px]">
            Promociones
          </div>
          <h2 className="font-primary text-[45px] mb-4">Nuestros Paquetes</h2>
        </div>

        <div className="grid grid-cols-1 max-w-sm mx-auto gap-[30px] md:grid-cols-2 lg:grid-cols-3 md:max-w-none lg:max-w-none lg:mx-0">
          {packages.slice(0, 3).map((pkg, index) => (
            <div
              key={pkg.id}
              className="h-full"
              data-aos="fade-up"
              data-aos-delay={index * 100}
              data-aos-duration="800"
            >
              <PackageCard pkg={pkg} />
            </div>
          ))}
        </div>

        {packages.length > 3 && (
          <div className="text-center mt-8">
            <Link
              to="/paquetes"
              className="btn btn-primary btn-sm"
            >
              Ver todos los paquetes
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default PackagesSection;
